import { GfeLogLevel } from './gfe-log.types';

const STACK_FRAME_SIGNATURE_LINE = 1;
const JSON_SIGNATURE_MAX_CHARS = 200;

export function computeLogSignature(
  level: GfeLogLevel,
  data: unknown,
  url: string
): string {
  const dataKey = describeData(data);
  return `${level}|${dataKey}|${url}`;
}

function describeData(data: unknown): string {
  if (data === null || data === undefined) {
    return 'null:';
  }

  if (isSerializedError(data)) {
    const stackFrame = extractFirstStackFrame(data.stack);
    return `error:${data.name ?? 'Error'}|${data.message}|${stackFrame}`;
  }

  if (typeof data === 'string') {
    return `string:${data}`;
  }

  return `json:${safeJsonStringify(data).slice(0, JSON_SIGNATURE_MAX_CHARS)}`;
}

function extractFirstStackFrame(stack: string | undefined): string {
  if (!stack) return '';
  const lines = stack.split('\n');
  return (lines[STACK_FRAME_SIGNATURE_LINE] ?? '').trim();
}

function isSerializedError(
  data: unknown
): data is { name?: string; message: string; stack?: string } {
  return (
    typeof data === 'object' &&
    data !== null &&
    typeof (data as { message?: unknown }).message === 'string'
  );
}

function safeJsonStringify(value: unknown): string {
  try {
    return JSON.stringify(value) ?? '';
  } catch {
    // Circular references etc. — fall back to a non-failing tag so the
    // signature stays stable instead of crashing the queue.
    return '<unserializable>';
  }
}
